var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 5.14844H12.625V2.5C12.625 2.08516 12.2898 1.75 11.875 1.75H2.3125V0.8125C2.3125 0.709375 2.22812 0.625 2.125 0.625H0.8125C0.709375 0.625 0.625 0.709375 0.625 0.8125V19.1875C0.625 19.2906 0.709375 19.375 0.8125 19.375H2.125C2.22812 19.375 2.3125 19.2906 2.3125 19.1875V13H8.125V15.6484C8.125 16.0633 8.46016 16.3984 8.875 16.3984H18.625C19.0398 16.3984 19.375 16.0633 19.375 15.6484V5.89844C19.375 5.48359 19.0398 5.14844 18.625 5.14844Z",
    fill: "#A09E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenge);
export default __webpack_public_path__ + "static/media/challenge.dbcfe604ca8c29c953f7020b284bf9e4.svg";
export { ForwardRef as ReactComponent };